const state = {
  isLoading: false,
  list: [],
  isTransporterListLoading: false,
  transporterWallet: [],
  page: 1,
  hasEmpty: false,
};

export default state;
